module.exports = __webpack_public_path__ + "img/dsci0035.441b890a.jpg";